import { Box, CircularProgress, Drawer, List } from '@mui/material';
import { PropsWithChildren } from 'react';
import { NavDrawerButton, NavLinkButton } from './nav-drawer-button';

interface NavDrawerProps {
    open: boolean;
    toggle(): void;
    buttons: NavLinkButton[];
    loading?: boolean;
}
export function NavDrawer({ children, open, toggle, buttons, loading }: PropsWithChildren<NavDrawerProps>) {
    return (
        <>
            <Drawer open={open} onClose={toggle}>
                {loading ? (
                    <Box
                        sx={{
                            display: 'grid',
                            justifyContent: 'center',
                            width: 200,
                            height: '100%',
                            alignItems: 'center',
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <List>
                        {buttons.map(button => (
                            <NavDrawerButton key={button.path} button={button} toggle={toggle} />
                        ))}
                    </List>
                )}
            </Drawer>
            <Box component='main'>{children}</Box>
        </>
    );
}
